<script>

import axios from 'axios';
import utilsService from '@/api/utilsService';
const apiUrl = `${process.env.VUE_APP_API_URL}/api/ficha`;
const apiUrlEcommerce = process.env.VUE_APP_API_URL; 

const getHeaders = () => ({
  'Authorization': `Bearer ${utilsService.getToken()}`,
  'Content-Type': 'application/json',
});

const fichaService = {

async create(formRaw) {
    try {
        const form = { ...formRaw };
      const { data } = await axios.post(`${apiUrl}/create`, form, { headers: getHeaders() });
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data || 'Error al crear el ingreso.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }
    }
  },

  async actualizar(formRaw) {
    try {
      // Espera un cuerpo con forma { idUsuario, ficha } y el id en la ruta
      const { id, request } = formRaw;
      if (!id) throw new Error('Id de ficha requerido para actualizar');
      const body = request || {};
      const { data } = await axios.put(`${apiUrl}/actualizar/${encodeURIComponent(id)}`, body, { headers: getHeaders() });
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data || 'Error al actualizar el ingreso.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }
    }
  },

  async actualizarPublicacion(idFicha, estadoPublicacion) {
    try {
      const { data } = await axios.patch(
        `${apiUrl}/publicacion/${encodeURIComponent(idFicha)}`,
        { estadoPublicacion },
        { headers: getHeaders() }
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || 'Error al actualizar publicación.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }
    }
  },

  async publicarFicha(idFicha) {
    return this.actualizarPublicacion(idFicha, 'P');
  },

  async obtenerPorId(id){
    const url = `${apiUrl}/obtener/${id}`;
    const { data } = await axios.get(url, { headers: getHeaders() });
    return data.data;
  },
  async getInfoGeneralYTecnica(token, idCriterio, numeroCluster, tipoFicha, idCluster, idDetalle, idFicha, lang = 'es') {
    const url = `${apiUrl}/getFichaInfoGeneralYTecnica/${encodeURIComponent(token)}/${encodeURIComponent(idCriterio)}/${encodeURIComponent(numeroCluster)}/${encodeURIComponent(tipoFicha)}/${encodeURIComponent(idCluster)}/${encodeURIComponent(idDetalle)}/${encodeURIComponent(idFicha)}?lang=${lang}`;
    const { data } = await axios.get(url, { headers: getHeaders() });
    return data;
  },
  async getFichaTerminosYCondicionesPrecio(token, idCriterio, numeroCluster, tipoFicha, idCluster, idDetalle, idFicha, lang = 'es') {
    const url = `${apiUrl}/getFichaTerminosYCondicionesPrecio/${encodeURIComponent(token)}/${encodeURIComponent(idCriterio)}/${encodeURIComponent(numeroCluster)}/${encodeURIComponent(tipoFicha)}/${encodeURIComponent(idCluster)}/${encodeURIComponent(idDetalle)}/${encodeURIComponent(idFicha)}?lang=${lang}`;
    const { data } = await axios.get(url, { headers: getHeaders() });
    return data;
  },

  async getFichaTerminosYCondicionesResumen(token, idCriterio, numeroCluster, tipoFicha, idCluster, idDetalle, idFicha, lang = 'es') {
    const url = `${apiUrl}/getFichaTerminosYCondicionesResumen/${encodeURIComponent(token)}/${encodeURIComponent(idCriterio)}/${encodeURIComponent(numeroCluster)}/${encodeURIComponent(tipoFicha)}/${encodeURIComponent(idCluster)}/${encodeURIComponent(idDetalle)}/${encodeURIComponent(idFicha)}?lang=${lang}`;
    const { data } = await axios.get(url, { headers: getHeaders() });
    return data;
  },
  
 // Método genérico: trae todos los archivos adjuntos de una familia+item
  async getArchivosByFamiliaAndItem(idFamilia, idItem) {
    const url = `${apiUrlEcommerce}/api/ArchivoAdjunto/familia/${idFamilia}/item/${encodeURIComponent(idItem)}`;
    const { data } = await axios.get(url, { headers: getHeaders() });
    return data && Array.isArray(data.data) ? data.data : [];
  },

 // Fotos del cluster resumen
  async getFotosClusterResumen(token, clusterId) {
    const items = await this.getArchivosByFamiliaAndItem(1, clusterId);
    return items.filter(x => Number(x.idTipoArchivo) === 2 || Number(x.IdTipoArchivo) === 2);
  },

  // Videos del cluster resumen
  async getVideosClusterResumen(token, clusterId) {
    const items = await this.getArchivosByFamiliaAndItem(1, clusterId);
    return items.filter(x => Number(x.idTipoArchivo) === 3 || Number(x.IdTipoArchivo) === 3);
  },

  // URL publica del PDF de la ficha. El endpoint es anonimo y responde con
  // Content-Disposition inline, asi que se puede abrir directo en otra pestana.
  getFichaPdfUrl(idFicha, lang = 'es') {
    return `${apiUrl}/getPdf/${encodeURIComponent(idFicha)}?lang=${encodeURIComponent(lang)}`;
  },

  async guardarDatosEquiposBulk(idFicha, idCluster, idUsuarioCreacion, items) {
    const body = { idFicha, idCluster, idUsuarioCreacion, items };
    const url = `${apiUrl}/datos-equipos/crear-bulk`;
    const { data } = await axios.put(url, body, { headers: getHeaders() });
    return data;
  },

  async guardarPreciosBulk(idFicha, idCluster, idUsuarioCreacion, items) {
    const body = { idFicha, idCluster, idUsuarioCreacion, items };
    const url = `${apiUrl}/precio/crear-bulk`;
    const { data } = await axios.put(url, body, { headers: getHeaders() });
    return data;
  },

  async actualizarOrden(idFicha, idCluster, items) {
    const body = {
      idFicha,
      idCluster,
      items
    };
    const url = `${apiUrl}/orden`;
    const { data } = await axios.put(url, body, { headers: getHeaders() });
    return data;
  },

  async subirArchivos(formData) {
    // El backend ahora espera: IdFicha, IdSeccion, Item, files como [FromForm]
    const headers = {
      "Authorization": "Bearer " + utilsService.getToken()
      // No especificamos Content-Type para que axios maneje multipart automáticamente
    };
    
    const url = `${apiUrl}/adjuntos/crear`;
    console.log("[subirArchivos > adjuntos/crear ] POST:", url);
    
    // El formData ya viene preparado desde el frontend con los campos correctos
    const resp = await axios.post(url, formData, { headers });
    return resp.data;
  },

  async getAnexosSubidos(idFicha) {
    const url = `${apiUrl}/adjuntos/${encodeURIComponent(idFicha)}`;
    const { data } = await axios.get(url, { headers: getHeaders() });
    //console.log("📎 Anexos subidos:", data);
    return Array.isArray(data.data) ? data.data : [];
  },

  async eliminarAnexo(idAnexo) {
    const url = `${apiUrl}/adjuntos/eliminar/${encodeURIComponent(idAnexo)}`;
    const { data } = await axios.delete(url, { headers: getHeaders() });
    return data;
  },
  

  // Servicio para obtener datos KAM
  async getDatosKam(idEmpresa) {
    if (!idEmpresa) return null;
    const url = `${apiUrl}/getDatosKam/${encodeURIComponent(idEmpresa)}`;
    const { data } = await axios.get(url, { headers: getHeaders() });
    return data;
  },

  async getPrellenadoDetalle(idMaterialETL) {
    if (!idMaterialETL) return null;
    const url = `${apiUrl}/prellenado-detalle/${encodeURIComponent(idMaterialETL)}`;
    const resp = await axios.get(url, { headers: getHeaders() });
    return resp && resp.data ? resp.data.data : null;
  },

  async getFichaPublica(idFicha, lang = 'es') {
    const { data } = await axios.get(`${apiUrl}/publica/${idFicha}`, { params: { lang } });
    return data;
  },

  async creaFichaMasiva(idFicha) {
    const { data } = await axios.post(`${apiUrl}/masiva/${idFicha}`, {}, { headers: getHeaders() });
    return data;
  },
};



export default fichaService;
</script>
